<!--
  GroupList.vue
    Group List Component
-->

<!-- -------------------------------------------------------------------------------- -->
<template>
  <div>
    <!-- グループ選択ボタン -->
    <!--<v-container text-xs-center>-->
    <div class="hm-gs hm-bg-primary hm-gs-selector" @click="onClickSelectGroup">
      {{ mSelectedDepartmentName }}
    </div>

    <!-- グループ選択Dialog(選択ボタン押下時に表示) -->
    <v-dialog
      :fullscreen="$vuetify.breakpoint.xsOnly"
      max-width="500px"
      v-model="mDialog"
      hide-overlay
      transition="slide-y-transition"
      scrollable
    >
      <v-card tile>
        <v-toolbar card dark color="primary" class="hm-iphonex-notch">
          <v-btn icon color="primary" @click="mDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>グループ選択</v-toolbar-title>
        </v-toolbar>
        <v-expansion-panel>
          <v-card class="hm-gs-groupcard-top">
            <v-card-text class="hm-clr-primary" @click="onClickDepartment('', null, '(全て)')">(全て)</v-card-text>
          </v-card>
          <v-expansion-panel-content v-for="section in mSectionList" :key="section.section_id">
            <div class="hm-clr-primary hm-gs-topgroup" slot="header">{{ section.s_name }}</div>
            <v-divider />
            <v-card class="hm-gs-groupcard">
              <v-card-text class="hm-clr-primary" @click="onClickDepartment(section.section_id, null, section.s_name)">{{ section.s_name }}(全て)</v-card-text>
            </v-card>
            <v-card class="hm-gs-groupcard" v-for="group in mGroupList" :key="group.group_id">
              <div v-if="group.section_id === section.section_id">
                <v-card-text class="hm-clr-primary" @click="onClickDepartment(null, group.group_id, group.g_name)">{{ group.g_name }}</v-card-text>
              </div>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-card>
    </v-dialog>
  </div>
</template>

<!-- -------------------------------------------------------------------------------- -->
<script>
import { mapState } from 'vuex'
import { LS_SECTION_ID, LS_GROUP_ID, isNullorUndefined } from '@/common'

export default {
  name: 'GroupList',
  data: () => ({
    mDialog: false,
    //mSelectedDepartmentId: '',
    mSelectedDepartmentName: '',
    mSelectedSectionId: '',
    mSelectedGroupId: '',
    _mSectionList: [],
    _mGroupList: [],
  }),
  components: {
  },
  mounted: function () {
    this.$log.debug('# GroupList')
    this.initializeAsync()
  },
  destroyed: function () {
    this.$log.debug('# GroupList')
  },
  computed: {
    ...mapState({
      // MainContent.vueの初期化時にSectionとGroupのListが取得される
      mSectionList: state => state.sSectionList,
      mGroupList: state => state.sGroupList,
    })
  },
  methods: {
    // -------------------------------------------------------------------------
    // 全グループリスト取得
    initializeAsync: async function () {
      try {
        this._searchSelectedName()
        // mount時は親要素(MemberPlaceList.vue)にグループ選択が変更されたことを明示的に通知
        this.$emit('selectedGroupChanged', this.mSelectedSectionId, this.mSelectedGroupId)
      }
      catch (err) {
        // 何もしない（エラーハンドリングは各メソッド内で行う）
      }
    },
    // -------------------------------------------------------------------------
    // グループ選択クリック時の処理
    onClickSelectGroup: function () {
      this.mDialog = true
    },
    // -------------------------------------------------------------------------
    // グループ選択時の処理
    // @remark sectionIdがnullの場合は、groupが選択されたとみなす
    //         sectionIdが''の場合は(全て)が選択されたとみなす
    onClickDepartment: function (sectionId, groupId, departmentName) {
      this.$log.debug('group clicked ' + sectionId + ':' + groupId + ':' + departmentName)
      this.mSelectedSectionId = sectionId
      this.mSelectedGroupId = groupId
      this.mSelectedDepartmentName = departmentName
      this.mDialog = false
      // ローカルストレージに選択したグループを保存
      localStorage.setItem(LS_SECTION_ID, this.mSelectedSectionId)
      localStorage.setItem(LS_GROUP_ID, this.mSelectedGroupId)
      // 親要素(MemberPlaceList.vue)にグループ選択が変更されたことを通知
      this.$emit('selectedGroupChanged', this.mSelectedSectionId, this.mSelectedGroupId)
    },
    // -------------------------------------------------------------------------
    // 選択済みグループ検索
    _searchSelectedName: function () {
      // ローカルから選択済みグループを取得
      let groupId = localStorage.getItem(LS_GROUP_ID)
      if (groupId === 'null') {  // nullをlocalStorageに保存するとnull文字列になる場合がある
        groupId = null
      }
      let sectionId = localStorage.getItem(LS_SECTION_ID)
      if (sectionId === 'null') {
        sectionId = null
      }
      if (sectionId === null && groupId === null) {
        sectionId = ''  // 全選択
      }
      this.$log.debug('section : ' + sectionId + ' group : ' + groupId)
      this.mSelectedGroupId = groupId
      this.mSelectedSectionId = sectionId
      this.mSelectedDepartmentName = this._searchDepartmentName(groupId, sectionId)
    },
    // -------------------------------------------------------------------------
    // search department name
    _searchDepartmentName: function (groupId, sectionId) {
      if (sectionId === '') {
        return '(全て)'
      }

      // search in sections
      if (!isNullorUndefined(sectionId)) {
        let section = this.mSectionList.find((section) => {
          return (section.section_id.toString() === sectionId.toString())  // toString()しないと比較に失敗する
        })
        if (!isNullorUndefined(section)) {
          return section.s_name
        }
      }

      // search in groups
      if (!isNullorUndefined(groupId)) {
        let group = this.mGroupList.find((group) => {
          return (group.group_id.toString() === groupId.toString())  // toString()しないと比較に失敗する
        })
        this.$log.debug(group)
        if (!isNullorUndefined(group)) {
          return group.g_name
        }
      }

      // 検索に一致しない場合は絞込なしとする
      //this.mSelectedDepartmentId = ''
      return '(全て)'
    },
  }
}
</script>

<!-- -------------------------------------------------------------------------------- -->
<style scoped>
.hm-gs {
  margin-top: 10px;
  margin-bottom: 10px;
}

.hm-gs-selector {
  padding: 5px;
  color: white;
  text-align: center;
  border-radius: 5px;          /* css3 draft */
  -webkit-border-radius: 5px;  /* Safari, Chrome */
  -moz-border-radius: 5px;     /* Firefox */
}
@media screen and (min-width: 601px) {
.hm-gs-selector {
  font-size: 1.5vw;
  font-weight: bold;
}
}

.hm-gs-topgroup {
  background-color: #ffebee;
}
.hm-gs-groupcard-top {
  width: 100%;
  text-align: center;
}
.hm-gs-groupcard-top:hover {
  background-color: #dddddd;
}
.hm-gs-groupcard:hover {
  background-color: #dddddd;
}
</style>



// WEBPACK FOOTER //
// src/components/GroupList.vue